import FilterRange from '../../configs/filter-data-selector-range';

export default {
    methods: {
        getDefaultRangeDates: function () {
            const endDate = new Date();
            const startDate = new Date();
            switch (this.defaultRange) {
                case FilterRange.MONTH:
                    startDate.setMonth(endDate.getMonth() - 1);
                    break;
            }
            return [startDate, endDate];
        },
    },
};
